import React from "react";
import { useTranslation } from "react-i18next";

export function SavingHint({ show }: { show: boolean }) {
  const { t } = useTranslation();

  if (!show) return null;
  return <div className="text-sm text-black/45">{t("billing.saving")}</div>;
}
